import { AccessPointService } from './../../../../services/access-controler/access-point.service';
import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Customer } from 'src/app/models';

@Component({
  selector: 'app-customer-catracas',
  templateUrl: './customer-catracas.component.html',
  styleUrls: ['./customer-catracas.component.scss'],
})
export class CustomerCatracasComponent implements OnInit {
  userToIntegration: any;
  integrarType: string;
  removeCatracas: boolean;

  points: any[] = [];
  constructor(
    public dialogRef: DynamicDialogRef,
    private config: DynamicDialogConfig,
    private AccessPointService: AccessPointService
  ) {}

  ngOnInit(): void {
    if (this.config.data) {
      if (this.config.data.removeCatracas) {
        this.removeCatracas = true;
      }

      if (this.config.data.customer != null) {
        this.integrarType = 'customer';
        this.userToIntegration = this.config.data.customer;
        this.userToIntegration.catracas.forEach((catraca) => {
          this.points.push({ catraca: catraca, status: null });
        });
        this.integrar();
      }
      if (this.config.data.sailor && this.config.data.sailor.catracas != null) {
        this.integrarType = 'sailor';
        this.userToIntegration = this.config.data.sailor;
        this.userToIntegration.catracas.forEach((catraca) => {
          this.points.push({ catraca: catraca, status: null });
        });
        this.integrar();
      }
    }

  }

  integrar() {
    this.points.forEach((point) => {
      if (this.removeCatracas) {
        this.AccessPointService.removerCatraca({
          accessPoint: point.catraca,
          userId: this.userToIntegration?.colectId,
          typeRegister: this.integrarType,
        }).subscribe((data) => {
          point.status = data;
        });
      } else {
        this.AccessPointService.ingetracaoCatraca({
          accessPoint: point.catraca,
          userId: this.userToIntegration?.id,
          typeRegister: this.integrarType,
        }).subscribe((data) => {
          point.status = data;
        });
      }
    });
  }

  fechar() {
    this.dialogRef.close(this.points);
  }

  reenviar(point) {
    point.status = null;
    if (this.removeCatracas) {
      this.AccessPointService.removerCatraca({
        accessPoint: point.catraca,
        userId: this.userToIntegration?.colectId,
        typeRegister: this.integrarType,
      }).subscribe((data) => {
        point.status = data;
      });
    } else {
      this.AccessPointService.ingetracaoCatraca({
        accessPoint: point.catraca,
        userId: this.userToIntegration?.id,
        typeRegister: this.integrarType,
      }).subscribe((data) => {
        point.status = data;
      });
    }
  }
}
